import React, { useState, useEffect, useContext, useMemo, useCallback, useRef } from 'react'
import Button from 'src/components//button/Button'
import Header from 'src/components//header/Header'
import styles from './orders.module.scss'
import axios from 'axios'
import { IOrder, IState } from 'src/Interface'
import { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import sub from 'date-fns/sub'
import format from 'date-fns/format'
import DatePicker from 'react-datepicker'
// import previousSaturday from 'date-fns/previousSaturday'
import "react-datepicker/dist/react-datepicker.css";
import { CSVLink } from "react-csv";
import { baseApiURL } from 'src/utils/utils'
import { useTable, useSortBy, usePagination, useGlobalFilter, useFilters } from 'react-table'
import { useLocation } from 'react-router-dom'
import { DispatchContext, StateContext } from '../../AppContext'
import Input from 'src/components/input/Input'
import diff from 'date-fns/differenceInDays'
import Checkbox from 'src/components/checkbox/Checkbox'
import { toast } from 'react-toastify'
import Footer from 'src/components/footer/Footer'
import Table from 'src/components/table/Table'
import SearchField from 'src/components/searchField/SearchField'
import useCancellablePromise from 'src/utils/useCancellablePromise'
import { isSunday, previousSaturday } from 'date-fns'

const Orders: React.FunctionComponent = () => {
  const location = useLocation()
  const referenceLabel = useRef(null)
  const [orders, setOrders] = useState([])
  const dispatch: React.Dispatch<any> = useContext(DispatchContext)
  const [showFilters, toggleFilter] = useState(false)
  const [loading, setLoading] = useState(true)
  const [minValue, setMinValue] = useState(null)
  const [maxValue, setMaxValue] = useState(null)
  const [response, setResponse] = useState({
    filters: {
      customerNames: [],
      destinationAddress: [],
      accounts: [],
      issuedByEmployees: [],
      issuedByBranches: [],
      issuedByCompanies: []
    },
    orders: []
  })
  const [selectedFilters, updateSelectedFilters] = useState<any>({
    customerNames: [],
    destinationAddress: [],
    accounts: [],
    issuedByEmployees: [],
    issuedByBranches: [],
    issuedByCompanies: []
  })
  const [filterValues, setFilterValues] = useState({
    customerNames: [],
    destinationAddress: [],
    issuedByEmployees: [],
    issuedByCompanies: [],
    issuedByBranches: [],
    accounts: []
  })
  const state: IState = useContext(StateContext)
  const [selectedDate, setSelectedDate] = useState(null)
  const [fromDate, setFromDate] = useState<Date>(sub(new Date(), { days: 10 }))
  const [toDate, setToDate] = useState<Date>(new Date())
  const [dateSelected, setDateSelected] = useState(false)
  const [currentFromDate, setCurrentFromDate] = useState<Date>(sub(new Date(), { days: 10 }))
  const [currentToDate, setCurrentToDate] = useState<Date>(new Date())
  const { cancellablePromise } = useCancellablePromise()

  useEffect(() => {
    if (state.user.companyId && state.user.accessToken)
      cancellablePromise(axios(`${baseApiURL()}/companies/${state.user.companyId}/booking_module`, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      })
        .then((result) => {
          referenceLabel.current = result.data.referenceLabel
        }).catch((err) => {
          toast(err.response.data.message)
        }))
  }, [state.user.accessToken, state.user.companyId, cancellablePromise])

  const fetchOrders = useCallback(
    (fromDate, toDate) => {
      if (state.user.accessToken) {
        setLoading(true)
        fromDate.setHours(0, 0, 0, 0)
        toDate.setHours(23, 59, 59, 59)
        cancellablePromise(axios(`${baseApiURL()}/orders/stats?fromDate=${fromDate.toISOString()}&toDate=${toDate.toISOString()}`, {
          headers: {
            Authorization:
              `Bearer ${state.user.accessToken}`
          }
        }).then((result) => {
          setResponse(result.data)
          setFilterValues(result.data.filters)
          setOrders(result.data.orders.filter((order: IOrder) => order.state === 'concluded'))
          dispatch({ type: 'SET_ORDERS', orders: result.data.orders.filter((order: IOrder) => order.state === 'concluded') })
          setLoading(false)
        }).catch((err) => {
          setLoading(false)
          toast(err.response.data.message)
        }))
      }
    }, [state.user.accessToken, dispatch, cancellablePromise]);

  const data = useMemo(() => orders, [orders])
  const columns = useMemo(() => [
    {
      Header: 'Dato',
      accessor: 'tripFinishedAt',
      Cell: (item: any) => <p className='tw-flex'><span className='tw-mr-10'>{format(new Date(item.value), 'dd/MM/yyyy')}</span> <span className='tw-opacity-50'>{format(new Date(item.value), 'HH:mm')}</span></p>

    },
    {
      Header: 'Konto',
      show: false,
      filter: filterAccount,
      accessor: 'account.name'
    },
    {
      Header: 'Kunde',
      filter: multiSelectFilter,
      accessor: 'customerName'
    },
    {
      filter: filterDestination,
      Header: 'Destination',
      accessor: 'destinationAddress.fullAddress'
    },
    {
      Header: 'Beløb',
      filter: filterPrice,
      accessor: 'finalPrice',
      Cell: (item: any) => <span>{item.value} kr.</span>
    },
    {
      Header: 'Lokation',
      filter: multiSelectFilter,
      accessor: 'issuedByBranch'
    },
    {
      Header: 'Virksomhed',
      filter: multiSelectFilter,
      accessor: 'issuedByCompany'
    },
    {
      Header: 'Medarbejder',
      filter: multiSelectFilter,
      accessor: 'issuedByEmployee'
    },
    {
      Header: 'OrderId',
      accessor: 'id'
    },
  ], [])

  const rapportData = state.orders.map(order => {
    if (state.user.role === 'DanTaxiAdmin') {
      return {
        Dato: `${format(new Date(order.tripFinishedAt), 'd/MM/yyyy')} ${format(new Date(order.tripFinishedAt), 'HH:mm')}`,
        Konto: order.account ? order.account.name : null,
        Kunde: order.customerName,
        Destination: order.destinationAddress ? order.destinationAddress.fullAddress : '',
        Beløb: order.finalPrice,
        Lokation: order.issuedByBranch,
        Virksomhed: order.issuedByCompany,
        Medarbejder: order.issuedByEmployee
      }
    } else if (state.user.role === 'CompanyAdmin') {
      return {
        Dato: `${format(new Date(order.tripFinishedAt), 'd/MM/yyyy')} ${format(new Date(order.tripFinishedAt), 'HH:mm')}`,
        Konto: order.account ? order.account.name : null,
        Kunde: order.customerName,
        Destination: order.destinationAddress ? order.destinationAddress.fullAddress : '',
        Beløb: order.finalPrice,
        Lokation: order.issuedByBranch,
        Medarbejder: order.issuedByEmployee
      }
    } else if (state.user.role === 'BranchAdmin') {
      return {
        Dato: `${format(new Date(order.tripFinishedAt), 'd/MM/yyyy')} ${format(new Date(order.tripFinishedAt), 'HH:mm')}`,
        Konto: order.account ? order.account.name : null,
        Kunde: order.customerName,
        Destination: order.destinationAddress ? order.destinationAddress.fullAddress : '',
        Beløb: order.finalPrice,
        Medarbejder: order.issuedByEmployee
      }
    } else {
      return {
        Dato: `${format(new Date(order.tripFinishedAt), 'd/MM/yyyy')} ${format(new Date(order.tripFinishedAt), 'HH:mm')}`,
        Konto: order.account ? order.account.name : null,
        Kunde: order.customerName,
        Destination: order.destinationAddress ? order.destinationAddress.fullAddress : '',
        Beløb: order.finalPrice,
      }
    }
  })

  const hiddenColumns: Array<string> = useMemo(() => {
    switch (state.user.role) {
      case 'CompanyAdmin':
        return ['issuedByCompany', 'id']
      case 'BranchAdmin':
        return ['issuedByBranch', 'issuedByCompany', 'id']
      case 'BranchEmployee':
        return ['issuedByBranch', 'issuedByCompany', 'issuedByEmployee', 'id']
      default:
        return ['id']
    }
  }, [state.user.role])


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    pageOptions,
    nextPage,
    filteredRows,
    setAllFilters,
    gotoPage,
    canNextPage,
    canPreviousPage,
    setGlobalFilter,
    state: pageState,
    previousPage,
    setFilter,
    prepareRow,
  } = useTable({
    initialState: {
      hiddenColumns
    },
    columns,
    data,
    autoResetPage: false
  }, useFilters, useGlobalFilter, useSortBy, usePagination)

  useEffect(() => {
    fetchOrders(currentFromDate, currentToDate)
  }, [currentFromDate, currentToDate, fetchOrders])

  const electricOrders = useMemo(() => filteredRows.filter(order => order.original.attributes.find(attribute => attribute.code === "EL") != null), [filteredRows])
  const electriOrdersFootprint = useMemo(() => Math.round(electricOrders.reduce((accumulator, order: any) => accumulator + order.original.estimatedTripDistance, 0)*0.000125), [electricOrders])

  const updateList = (name: string, category: string) => (checked: boolean) => {
    const filterCategories: Record<string, string> = {
      destinationAddress: 'destinationAddress.fullAddress',
      customerNames: 'customerName',
      accounts: 'account.name',
      issuedByBranches: 'issuedByBranch',
      issuedByCompanies: 'issuedByCompany',
      issuedByEmployees: 'issuedByEmployee'
    }
    const filterCategory = filterCategories[category]
    if (checked) {
      updateSelectedFilters({
        ...selectedFilters,
        [category]: [...selectedFilters[category], name]
      })
      setFilter(filterCategory, [...selectedFilters[category], name])
    } else {
      const selectedFilterOptionsCopy = { ...selectedFilters }
      selectedFilterOptionsCopy[category].splice(selectedFilters[category].findIndex((n: any) => n === name), 1)
      updateSelectedFilters(selectedFilterOptionsCopy)
      setFilter(filterCategory, selectedFilterOptionsCopy[category])
    }
  }

  const search = (category: string) => (value: string) => {
    const filters = { ...filterValues }
    switch (category) {
      case 'customerNames':
        filters.customerNames = value ? response.filters.customerNames.filter(customerName => customerName.name.toLowerCase().includes(value.toLowerCase())) : response.filters.customerNames
        break;

      case 'destinationAddress':
        filters.destinationAddress = value ? response.filters.destinationAddress.filter(({ address }) => address.fullAddress.toLowerCase().includes(value.toLowerCase())) : response.filters.destinationAddress
        break;

      case 'accounts':
        filters.accounts = value ? response.filters.accounts.filter(({ account }) => account.name.toLowerCase().includes(value.toLowerCase())) : response.filters.accounts
        break;

      case 'issuedByBranches':
        filters.issuedByBranches = value ? response.filters.issuedByBranches.filter(({ name }) => name.toLowerCase().includes(value.toLowerCase())) : response.filters.issuedByBranches
        break;

      case 'issuedByCompanies':
        filters.issuedByCompanies = value ? response.filters.issuedByCompanies.filter(({ name }) => name.toLowerCase().includes(value.toLowerCase())) : response.filters.issuedByCompanies
        break;

      case 'issuedByEmployees':
        filters.issuedByEmployees = value ? response.filters.issuedByEmployees.filter(({ name }) => name.toLowerCase().startsWith(value.toLowerCase())) : response.filters.issuedByEmployees
        break;

      default:
        break;
    }
    setFilterValues(filters)
  }

  function multiSelectFilter(rows, columnIds, filterValue) {
    return filterValue.length === 0
      ? rows
      : rows.filter((row) =>
        filterValue.includes(String(row.original[columnIds])),
      );
  }

  function filterPrice(rows: any, id: any, filterValue: Array<string>) {
    const [min, max] = filterValue
    return filterValue.length === 0 ? rows : rows.filter((row: any) => row.original.finalPrice >= min && row.original.finalPrice <= max)
  }

  function filterAccount(rows: any, id: any, filterValue: Array<number>) {
    return filterValue.length === 0 ? rows : rows.filter((row: any) => {
      if (!row.original.account) {
        return false
      }

      return filterValue.find(value => value === row.original.account.name) ? true : false
    })
  }

  function filterDestination(rows: any, id: any, filterValue: Array<number>) {
    return filterValue.length === 0 ? rows : rows.filter((row: any) => {
      if (!row.original.destinationAddress) {
        return false
      }

      return filterValue.find(value => value === row.original.destinationAddress.fullAddress) ? true : false
    })
  }

  const dateFilterButtons = useMemo(() => [
    {
      label: 'Sidste uge',
      modifiers: 'tw-mb-3 tw-mr-auto',
      date: sub(new Date(), { weeks: 1 }),
    },
    {
      label: 'Sidste weekend',
      modifiers: 'tw-mb-3',
      date: isSunday(new Date()) ? sub(new Date(), { days: 8 }) : previousSaturday(new Date()),
    },
    {
      label: 'Sidste 30 dage',
      modifiers: 'tw-mr-auto',
      date: sub(new Date(), { days: 30 }),
    },
    {
      label: 'Sidste år',
      modifiers: '',
      date: sub(new Date(), { years: 1 })
    }
  ], [])

  const combinedSelectedFilters = useMemo(() => [
    ...selectedFilters.customerNames.map((customerName: any) => {
      return {
        name: customerName,
        category: 'customerNames'
      }
    }),
    ...selectedFilters.issuedByEmployees.map((employee: string) => {
      return {
        name: employee,
        category: 'issuedByEmployees'
      }
    }),
    ...selectedFilters.issuedByBranches.map((branch: string) => {
      return {
        name: branch,
        category: 'issuedByBranches'
      }
    }),
    ...selectedFilters.issuedByCompanies.map((company: string) => {
      return {
        name: company,
        category: 'issuedByCompanies'
      }
    }),
    ...selectedFilters.destinationAddress.map((address: any) => {
      return {
        name: address,
        category: 'destinationAddress'
      }
    }),
    ...selectedFilters.accounts.map((account: any) => {
      return {
        name: account,
        category: 'accounts'
      }
    })
  ], [selectedFilters])

  return (
    <>
      <Header />
      <div className='tw-flex tw-flex-auto'>
        <aside className={`${styles.filterContainer} ${showFilters ? styles.animate : ''}`}>
          <header className={styles.filterHeader}>
            {showFilters && <h4 className={styles.subtitle}>Filtre</h4>}
            {!loading && <span className={styles.filterIcon} onClick={() => toggleFilter(!showFilters)}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clipRule="evenodd" />
              </svg>
            </span>}
          </header>
          {showFilters && <div className={styles.filterContent}>
            <div className={styles.filterItem}>
              <input type="checkbox" id="date" className={styles.input} />
              <label htmlFor='date' className={styles.filterItemHeader}>
                <span className='tw-font-medium tw-text-sm tw-mr-auto '>Dato</span>
                {dateSelected && <span className='tw-mr-3 tw-opacity-50 tw-text-sm self-center tw-flex'>
                  {format(currentFromDate, 'd/MM/yyyy')}
                  <svg className='tw-w-4 tw-h-4 tw-ml-2 tw-mr-2' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                  {format(currentToDate, 'd/MM/yyyy')}</span>}
                <svg className={styles.filterItemIcon} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </label>
              <div className={styles.filterItemContent}>
                <div className='tw-flex tw-items-center tw-mb-5 tw-flex-wrap'>
                  {dateFilterButtons.map((button, index) =>
                    <Button key={index} modifiers={button.modifiers} type={selectedDate === button.label ? 'addonActive' : 'addon'} handleClick={() => {
                      setFromDate(button.label === selectedDate ? sub(new Date(), { days: 10 }) : button.date)
                      setSelectedDate(button.label === selectedDate ? fromDate : button.label)
                    }}
                      label={button.label} />)}
                </div>

                <div className='tw-flex tw-items-center tw-mb-5'>
                  <DatePicker
                    selected={fromDate || sub(new Date(), { days: 10 })}
                    onChange={(date: any) => { setFromDate(date); setSelectedDate('') }}
                    maxDate={toDate}
                    className={styles.datePicker}
                    startDate={fromDate}
                  />
                  <span className={styles.arrowIcon}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </span>
                  <DatePicker
                    selected={selectedDate ? new Date() : toDate}
                    onChange={(date: any) => { setToDate(date); setSelectedDate('') }}
                    minDate={fromDate}
                    maxDate={new Date()}
                    className={styles.datePicker}
                    startDate={toDate}
                  />
                </div>
                <Button disabled={!(selectedDate || fromDate || toDate)} type='primary' label='Apply' handleClick={() => {
                  setCurrentFromDate(fromDate)
                  setCurrentToDate(toDate)
                  setDateSelected(true)
                  fetchOrders(fromDate, toDate)
                }} modifiers='mt-5 tw-ml-auto tw-w-full tw-justify-center' />
              </div>
            </div>
            <div className={styles.filterItem}>
              <input type="checkbox" id="customers" className={styles.input} />
              <label htmlFor='customers' className={styles.filterItemHeader}>
                <span className='tw-font-medium tw-text-sm tw-mr-auto'>Kunde</span>
                {selectedFilters.customerNames.length > 0 && <span className='tw-mr-3 tw-opacity-50 tw-text-xs self-center'>{`${selectedFilters.customerNames.length} ${selectedFilters.customerNames.length === 1 ? 'valgt' : 'valgte'}`}</span>}
                <svg className={styles.filterItemIcon} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </label>
              <div className={styles.filterItemContent}>
                <Input modifiers='tw-mb-2' searchIcon={true} placeholder='Søg kunde' name='date' type='text' handleInputChange={() => search('customerNames')} />
                <ul>
                  {filterValues.customerNames.map((item, i) => (
                    <li className='tw-flex tw-items-center' key={i}>
                      <Checkbox modifiers='tw-py-3' checked={selectedFilters.customerNames.includes(item.name)} name='r' labelRight={item.name} handleChange={() => updateList(item.name, 'customerNames')} />
                      <span className='tw-ml-auto tw-text-sm tw-opacity-50'>{item.occurrences}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            {state.user.role !== 'BranchEmployee' && <div className={styles.filterItem}>
              <input type="checkbox" id="users" className={styles.input} />
              <label htmlFor='users' className={styles.filterItemHeader}>
                <span className='tw-font-medium tw-text-sm tw-mr-auto'>Medarbejder</span>
                {selectedFilters.issuedByEmployees.length > 0 && <span className='tw-mr-3 tw-opacity-50 tw-text-xs self-center'>{`${selectedFilters.issuedByEmployees.length} ${selectedFilters.issuedByEmployees.length === 1 ? 'valgt' : 'valgte'}`}</span>}
                <svg className={styles.filterItemIcon} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </label>
              <div className={styles.filterItemContent}>
                <Input modifiers='tw-mb-2' searchIcon={true} placeholder='Søg medarbejder' name='date' type='text' handleInputChange={() => search('issuedByEmployees')} />
                <ul>
                  {filterValues.issuedByEmployees.map((item, i) => (
                    <li className='tw-flex tw-items-center' key={i}>
                      <Checkbox modifiers='tw-py-3' checked={selectedFilters.issuedByEmployees.includes(item.name)} name={item.name} labelRight={item.name} handleChange={() => updateList(item.name, 'issuedByEmployees')} />
                      <span className='tw-ml-auto tw-text-sm tw-opacity-50'>{item.occurrences}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>}
            {(state.user.role === 'DanTaxiAdmin' || state.user.role === 'CompanyAdmin') && <div className={styles.filterItem}>
              <input type="checkbox" id="location" className={styles.input} />
              <label htmlFor='location' className={styles.filterItemHeader}>
                <span className='tw-font-medium tw-text-sm tw-mr-auto'>Lokation</span>
                {selectedFilters.issuedByBranches.length > 0 && <span className='tw-mr-3 tw-opacity-50 tw-text-xs self-center'>{`${selectedFilters.issuedByBranches.length} ${selectedFilters.issuedByBranches.length === 1 ? 'valgt' : 'valgte'}`}</span>}
                <svg className={styles.filterItemIcon} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </label>
              <div className={styles.filterItemContent}>
                <Input modifiers='tw-mb-2' searchIcon={true} placeholder='Søg lokation' name='date' type='text' handleInputChange={() => search('issuedByBranches')} />
                <ul>
                  {filterValues.issuedByBranches.map((item, i) => (
                    <li className='tw-flex tw-items-center' key={i}>
                      <Checkbox modifiers='tw-py-3' checked={selectedFilters.issuedByBranches.includes(item.name)} name='r' labelRight={item.name} handleChange={() => updateList(item.name, 'issuedByBranches')} />
                      <span className='tw-ml-auto tw-text-sm tw-opacity-50'>{item.occurrences}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>}
            {state.user.role === 'DanTaxiAdmin' && <div className={styles.filterItem}>
              <input type="checkbox" id="company" className={styles.input} />
              <label htmlFor='company' className={styles.filterItemHeader}>
                <span className='tw-font-medium tw-text-sm tw-mr-auto'>Virksomhed</span>
                {selectedFilters.issuedByCompanies.length > 0 && <span className='tw-mr-3 tw-opacity-50 tw-text-xs self-center'>{`${selectedFilters.issuedByCompanies.length} ${selectedFilters.issuedByCompanies.length === 1 ? 'valgt' : 'valgte'}`}</span>}
                <svg className={styles.filterItemIcon} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </label>
              <div className={styles.filterItemContent}>
                <Input modifiers='tw-mb-2' searchIcon={true} placeholder='Søg virksomhed' name='date' type='text' handleInputChange={() => search('issuedByCompanies')} />
                <ul>
                  {filterValues.issuedByCompanies.map((item, i) => (
                    <li className='tw-flex tw-items-center' key={i}>
                      <Checkbox modifiers='tw-py-3' checked={selectedFilters.issuedByCompanies.includes(item.name)} name='r' labelRight={item.name} handleChange={() => updateList(item.name, 'issuedByCompanies')} />
                      <span className='tw-ml-auto tw-text-sm tw-opacity-50'>{item.occurrences}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>}
            <div className={styles.filterItem}>
              <input type="checkbox" id="destination" className={styles.input} />
              <label htmlFor='destination' className={styles.filterItemHeader}>
                <span className='tw-font-medium tw-text-sm tw-mr-auto'>Destination</span>
                {selectedFilters.destinationAddress.length > 0 && <span className='tw-mr-3 tw-opacity-50 tw-text-xs self-center'>{`${selectedFilters.destinationAddress.length} ${selectedFilters.destinationAddress.length === 1 ? 'valgt' : 'valgte'}`}</span>}
                <svg className={styles.filterItemIcon} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </label>
              <div className={styles.filterItemContent}>
                <Input modifiers='tw-mb-2' searchIcon={true} placeholder='Søg destination' name='date' type='text' handleInputChange={() => search('destinationAddress')} />
                <ul>
                  {filterValues.destinationAddress.map((item, i) => {
                    return (
                      <li className='tw-flex tw-items-center' key={i}>
                        <Checkbox modifiers='tw-py-3' checked={selectedFilters.destinationAddress.includes(item.address.fullAddress)} name='re' labelRight={item.address.fullAddress} handleChange={() => updateList(item.address.fullAddress, 'destinationAddress')} />
                        <span className='tw-ml-auto tw-text-sm tw-opacity-50'>{item.occurrences}</span>
                      </li>
                    )
                  })}
                </ul>
              </div>
            </div>
            <div className={styles.filterItem}>
              <input type="checkbox" id="accounts" className={styles.input} />
              <label htmlFor='accounts' className={styles.filterItemHeader}>
                <span className='tw-font-medium tw-text-sm tw-mr-auto'>Konto</span>
                {selectedFilters.accounts.length > 0 && <span className='tw-mr-3 tw-opacity-50 tw-text-xs self-center'>{`${selectedFilters.accounts.length} ${selectedFilters.accounts.length === 1 ? 'valgt' : 'valgte'}`}</span>}
                <svg className={styles.filterItemIcon} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </label>
              <div className={styles.filterItemContent}>
                <Input searchIcon={true} modifiers='tw-mb-2' placeholder='Søg konto' name='date' type='text' handleInputChange={() => search('accounts')} />
                <ul>
                  {filterValues.accounts.map((item, i) => (
                    <li className='tw-flex tw-items-center' key={i}>
                      <Checkbox modifiers='tw-py-3' checked={selectedFilters.accounts.includes(item.account.name)} name='r' labelRight={item.account.name} handleChange={() => updateList(item.account.name, 'accounts')} />
                      <span className='tw-ml-auto tw-text-sm tw-opacity-50'>{item.occurrences}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            {Math.min(...state.orders.map(order => order.finalPrice)) !== Math.max(...state.orders.map(order => order.finalPrice)) && <div className={styles.filterItem}>
              <input type="checkbox" id="price" className={styles.input} />
              <label htmlFor='price' className={styles.filterItemHeader}>
                <span className='tw-font-medium tw-text-sm tw-mr-auto'>Beløb</span>
                {minValue && maxValue && <span className='tw-mr-3 tw-opacity-50 tw-text-xs self-center'>{`${minValue} - ${maxValue} kr.`}</span>}

                <svg className={styles.filterItemIcon} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </label>
              {state.orders.filter(order => order.finalPrice).length > 0 &&
                <div className={`${styles.filterItemContent} pl-3 pr-3`}>
                  <Range
                    allowCross={false}
                    className={styles.range}
                    min={Math.min(...state.orders.map(order => order.finalPrice))}
                    max={Math.max(...state.orders.map(order => order.finalPrice))}
                    value={minValue && maxValue ? [minValue, maxValue] : [Math.min(...state.orders.map(order => order.finalPrice)), Math.max(...state.orders.map(order => order.finalPrice))]}
                    ariaLabelGroupForHandles={['min', 'max']}
                    onChange={(([min, max]) => {
                      setMinValue(min)
                      setMaxValue(max)
                      setFilter('finalPrice', [min, max])
                    })} />
                  <div className='tw-flex tw-items-center mt-2'>
                    <span>{Math.round(minValue || Math.min(...state.orders.map(order => order.finalPrice)))} kr.</span>
                    <span className='tw-ml-auto'>{Math.round(maxValue || Math.max(...state.orders.map(order => order.finalPrice)))} kr.</span>
                  </div>
                </div>}
            </div>}
          </div>}
        </aside>
        <div className={styles.container}>
          <div className={styles.header}>
            {!loading && <>
              {dateSelected ? <h3 className='tw-flex tw-items-center'>
                {format(currentFromDate, 'd. MMM, yyyy')}
                <span className={styles.arrowIconLarge}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg></span>
                {format(currentToDate, 'd. MMM, yyyy')}
              </h3> :
                <h3>Overblik</h3>}
              <SearchField modifiers='tw-ml-auto' handleInputChange={(value) => setGlobalFilter(value)} name='search' label='Søg' />
              <Button modifiers='tw-ml-5' type='primary' disabled={!state.orders.length}>
                <svg className='h-4 w-4 mr-3' xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13l-3 3m0 0l-3-3m3 3V8m0 13a9 9 0 110-18 9 9 0 010 18z" />
                </svg>
                <CSVLink onClick={() => !state.orders.length ? false : true} filename='rapport' data={rapportData} target='_blank'>Hent rapport</CSVLink>
              </Button>
            </>}
          </div>
          <main className={styles.content}>
            <div className={styles.boxes}>
              <div className={`${styles.box} ${loading ? `${styles.boxLoading} animate-pulse` : ''}`}>
                <h3 className={styles.boxTitle}>{filteredRows.length}</h3>
                <p className={styles.boxText}>Kørsler</p>
              </div>
              <div className={`${styles.box} ${loading ? `${styles.boxLoading} animate-pulse` : ''}`}>
                <h3 className={styles.boxTitle}>{Math.round((filteredRows.length / (diff(currentToDate, currentFromDate) > 0 ? diff(currentToDate, currentFromDate) : 1) + Number.EPSILON) * 100) / 100 || 0}</h3>
                <p className={styles.boxText}>Gnms. kørsler pr. dag</p>
              </div>
              <div className={`${styles.box} ${loading ? `${styles.boxLoading} animate-pulse` : ''}`}>
                <h3 className={styles.boxTitle}>{`${Math.round(filteredRows.reduce((accumulator, order: any) => accumulator + order.original.finalPrice, 0) / filteredRows.length) || 0}  kr.`}</h3>
                <p className={styles.boxText}>Gns. pris</p>
              </div>
              <div className={`${styles.box} ${loading ? `${styles.boxLoading} animate-pulse` : ''}`}>
                <h3 className={styles.boxTitle}>{electricOrders.length}</h3>
                <p className={styles.boxText}>Elbils ture</p>
              </div>
              <div className={`${styles.box} ${loading ? `${styles.boxLoading} animate-pulse` : ''}`}>
                <h3 className={styles.boxTitle}>{electriOrdersFootprint}</h3>
                <p className={styles.boxText}>CO2/kg sparet</p>
              </div>
            </div>
            <div className='tw-flex tw-flex-wrap'>
              {combinedSelectedFilters.map((item, i) => {
                return (
                  <button key={i} onClick={() => updateList(item.name, item.category)(false)} className={`${styles.selectedFilterButton} tw-mr-3 tw-mb-5`}>
                    <span className={styles.selectedFilterButtonIcon}>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </span>
                    {item.name}
                  </button>
                )
              })}
              {minValue && maxValue && <button onClick={() => { setMaxValue(null); setMinValue(null); setFilter('finalPrice', [Math.min(...state.orders.map(order => order.finalPrice)), Math.max(...state.orders.map(order => order.finalPrice))]) }} className={`${styles.selectedFilterButton}  tw-mr-3 tw-mb-5`}>
                <span className={styles.selectedFilterButtonIcon}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </span>
                {`${minValue} - ${maxValue} kr.`}
              </button>}

              {(combinedSelectedFilters.length > 0 || (minValue && maxValue)) &&
                <>
                  <span className={styles.filterDivider} />
                  <button className={styles.clearFilters} onClick={() => {
                    setMinValue(null)
                    setMaxValue(null)
                    setAllFilters([])
                    updateSelectedFilters({
                      customerNames: [],
                      destinationAddress: [],
                      accounts: [],
                      issuedByEmployees: [],
                      issuedByCompanies: [],
                      issuedByBranches: []
                    })
                  }}>Nulstil</button>
                </>}
            </div>
            <Table
              getTableBodyProps={getTableBodyProps}
              getTableProps={getTableProps}
              prepareRow={prepareRow}
              page={page}
              headerGroups={headerGroups}
              type='orders'
              handleClick={(orderId) => dispatch({ type: 'SHOW_ASIDE', asideType: 'OrdersDetails', show: true, orderId, referenceLabel: referenceLabel.current })}
              loading={loading}
              state={{ background: location, test: 'test' }}
            />
          </main>
        </div>
      </div>
      <Footer
        pageState={pageState}
        canNextPage={canNextPage}
        nextPage={nextPage}
        canPreviousPage={canPreviousPage}
        page={page}
        paginationLabel='ture'
        gotoPage={gotoPage}
        loading={loading}
        previousPage={previousPage}
        pageOptions={pageOptions}
        itemsLength={filteredRows.length}
      />
    </>
  )
}

export default Orders